'use strict';
var KeyMirror = require('keymirror');
var UrlService = require('../services/UrlService');

var baseUrl = UrlService.getApplicationPath() + 'api/';
var _yesNoValues = {
    YES: 'Y',
    NO: 'N',
    YES_LONG: 'Yes',
    NO_LONG: 'No'
};

var _productIds = {
    SUPER: 11,
    PENSION: 51,
    INVESTMENT: 91,
    COMMINSURE: 141,
    CHALLENGER: 142
}
var _accountTypeCodes = {
    INDIVIDUAL: 'I',
    JOINT: 'J',
    COMPANY: 'C',
    PARTNERSHIP: 'P',
    SMSF: 'S',
    SOLE_TRADER: 'ST',
    TRUST: 'T'
}

const _trusteeTypeLabels = {
    i: 'Individual',
    c: 'Corporate'
};

var _originationSources = {
    FIRSTNET: 'FirstNet',
    IRESS: 'Iress'
};

var _originationTypes = {
    INTEGRATED: 'Integrated',
    NON_INTEGRATED: 'NonIntegrated',
    OTHER: 'Other'
};

var _formKeys = {
    INDIVIDUAL_INVESTMENT: _accountTypeCodes.INDIVIDUAL + '-' + _productIds.INVESTMENT,
    JOINT_INVESTMENT: _accountTypeCodes.JOINT + '-' + _productIds.INVESTMENT,
    COMPANY_INVESTMENT: _accountTypeCodes.COMPANY + '-' + _productIds.INVESTMENT,
    PARTNERSHIP_INVESTMENT: _accountTypeCodes.PARTNERSHIP + '-' + _productIds.INVESTMENT,
    SMSF_INVESTMENT: _accountTypeCodes.SMSF + '-' + _productIds.INVESTMENT,
    SOLE_TRADER_INVESTMENT: _accountTypeCodes.SOLE_TRADER + '-' + _productIds.INVESTMENT,
    TRUST_INVESTMENT: _accountTypeCodes.TRUST + '-' + _productIds.INVESTMENT,
    INDIVIDUAL_COMMINSURE: _accountTypeCodes.INDIVIDUAL + '-' + _productIds.COMMINSURE,
    JOINT_COMMINSURE: _accountTypeCodes.JOINT + '-' + _productIds.COMMINSURE,
    COMPANY_COMMINSURE: _accountTypeCodes.COMPANY + '-' + _productIds.COMMINSURE,
    SMSF_COMMINSURE: _accountTypeCodes.SMSF + '-' + _productIds.COMMINSURE,
    TRUST_COMMINSURE: _accountTypeCodes.TRUST + '-' + _productIds.COMMINSURE,
    INDIVIDUAL_CHALLENGER: _accountTypeCodes.INDIVIDUAL + '-' + _productIds.CHALLENGER,
    JOINT_CHALLENGER: _accountTypeCodes.JOINT + '-' + _productIds.CHALLENGER,
    COMPANY_CHALLENGER: _accountTypeCodes.COMPANY + '-' + _productIds.CHALLENGER,
    SMSF_CHALLENGER: _accountTypeCodes.SMSF + '-' + _productIds.CHALLENGER,
    TRUST_CHALLENGER: _accountTypeCodes.TRUST + '-' + _productIds.CHALLENGER
}

var formModel = {
    id: '',
    complete: false,
    productId: '',
    originationSource: '',
    originationType: '',
    applicationLinkType: '',
    hasDigitalSignature: '',
    form: {
        accountType: '',
        yourDetails: {},
        investmentAllocation: {
            ModelPortfolioId: '',
            consolidateContributionsForTermDeposits: '',
            investmentAllocations: [],
            assetAllocations: []
        },
        adviceFee: {
            adviceFeeOption: '',
            IsFeesExcessive: false,
            AdviceFeesList: []
        },
        autoRebalancing: {
            SetAutoRebalancing: _yesNoValues.NO,
            Frequency: ''
        },
        onlineAccess: [],
        portfolioRebate: {
            portfolioRebateOption: '',
            investmentOption: '',
            linkAccountOption: ''
        },
        regularInvestmentPlan: {
            ripOption: '',
            personalContribution: '',
            spouseContribution: '',
            monthlyAmountContribution: '',
            selectedBankAccount: '',
            nameOfAccountHolder: '',
            bankAccountHeldOption: '',
            branchNumber: '',
            bankAccount: '',
            sameAsInvestAllocationOption: '',
            investmentOptionList: [],
            consumerPriceIndex: ''
        },
        fundingYourProduct: {
            fundingSources: [],
            totalAmount: ''
        },
        beneficiary: {
            isNominateBeneficiary: '',
            type: '',
            gender: '',
            title: '',
            givenName: '',
            lastName: '',
            relationship: '',
            dateOfBirth: '',
            defineAddressLine: '',
            residential: '',
            resCountry: '',
            address1: '',
            address2: '',
            cityStatePostCode: '',
            resAusState: '',
            postCode: '',
            mobileNumber: '',
            homeNumber: '',
            workNumber: '',
            emailAddress: ''
        },
        idVerification: null,
        inSpecieTransfer: {
            setUp: '',
            externalAccountQuestion: '',
            inSpecieAccounts: ''
        },
        workItem: {
            fileNote: null,
            confirmDetailsBackFile: null,
            idVerificationBackFile: null
        }
    }
};

var _daysOfTheWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var _monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

module.exports = {
    ApplicationLoadingViews: KeyMirror({
        APPLICATION_FORM: null,
        CLIENT_SELECT: null
    }),
    ActionTypes: KeyMirror({
        SET_PRODUCT_ID: null,
        NEW_APPLICATION_INITIALISED: null,
        APPLICATION_RETRIEVE_STARTING: null,
        APPLICATION_RETRIEVE_SUCCESS: null,
        APPLICATION_RETRIEVE_ERROR: null,
        APPLICATION_SAVE_STARTING: null,
        APPLICATION_SAVE_REQUEST: null,
        APPLICATION_SAVE_SUCCESS: null,
        APPLICATION_SAVE_ERROR: null,
        APPLICATION_SAVE_VALIDATE: null,
        APPLICATION_SUBMIT_STARTING: null,
        APPLICATION_SUBMIT_SUCCESS: null,
        APPLICATION_SUBMIT_FAILED: null,
        APPLICATION_REVIEW_REQUEST: null,
        RECEIVE_PRODUCT_LIST: null,
        HIDE_ADVISER_FEE: null,
        SHOW_ERROR_BAR: null,
        CLEAR_ERROR_LIST: null,
        GET_KYC_FLAG: null,
        GOTO_FIELD_WITH_ERROR: null,
        RECEIVE_ASSET_ALLOCATIONS: null,
        VALIDATE_APPLICATION: null,
        SEND_INVESTMENT_OPTIONS: null,
        REVIEW_APPLICATION: null,
        SET_ADVISER_FEE_TYPE_OPTIONS: null,
        SEND_BANK_ACCOUNT_DETAILS: null,
        SEND_YOUR_DETAIL_DOB: null,
        LOAD_TITLE_LIST: null,
        LOAD_TFN_EXEMPTION_LIST: null,
        SEND_CLIENT_ACCOUNT_DETAILS: null,
        LOAD_COUNTRY_LIST: null,
        SEND_FUNDING_AMOUNT: null,
        IS_FUNDING_SUMMARY: null,
        SEND_RIP_ANSWER: null,
        SEND_IS_SUPER_FIRST_TRANSFER: null,
        SET_IDVERIFICATION_VALIDATIONS: null,
        AGREE_IDVERIFICATION_FORM: null,
        UPDATE_VERIFICATOIN_DOCUMENT: null,
        UPDATE_FILTERED_OPTIONS: null,
        REMOVE_IDVERIFICATION_DOCUMENT: null,
        UPDATE_IDVERIFICATION_DOCUMENT: null,
        CHANGE_IDVERIFICATION_DOCUMENT: null,
        START_EDIT_IDVERIFICATION_DOCUMENT: null,
        CANCEL_EDIT_IDVERIFICATION_DOCUMENT: null,
        FINISH_EDIT_IDVERIFICATION_DOCUMENT: null,
        CLIENT_IDENTIFICATION_MODE_START_LOADING: null,
        CLIENT_IDENTIFICATION_MODE_LOADED: null,
        SET_COMMSEE_BACKFILE: null,
        SET_WORKITEM: null,
        UPDATE_WORKITEM: null,
        SEND_INSPECIE_DECISIONS: null,
        SEND_INSPECIE_DATA: null,
        SHOW_MORE_MENU: null,
        RECEIVE_ANNUITY_QUOTE_URL: null,
        SET_ASSET_ALLOCATIONS: null,
        UPDATE_SPECIAL_REQUESTS: null,
        UPDATE_ADVISER_TRANSACT_AUTHORITY :null,
        UPDATE_ADVISER_ATTESTATION: null,
        EDIT_SECTION: null,
        UPDATE_INCOME_DISTRIBUTION_MODEL: null,
        RECEIVED_IS_PRODUCT_REGISTERED: null,
        SET_APPLICATION_LINK_TYPE: null,
        SEND_BANK_ACCOUNT_FROM_RIP: null,
        SEND_INVESTOR_DETAILS_TEMP: null,
        SEND_PORTFOLIO_REBATE_DETAILS: null,
        IS_PRE_RETIREMENT: null,
        SEND_RIP_MODEL: null,
        SEND_ELIGIBLE_CONTRIBUTION_FROM_RIP: null,
        SEND_SHOW_RIP_SECTION: null,
        SEND_PENSION_TYPE_OPTIONS: null,
        SEND_PENSION_PAYMENT_DRAW_DOWN_OPTION: null,
        SAVE_WORKFILE: null,
        SHOW_DOWNLOAD_MENU: null,
        DOWNLOAD_FORMS_SUCCESS: null,
        UPDATE_FORMS_TO_DOWNLOAD: null,
        PREPARE_FORMS_TO_DOWNLOAD: null,
        START_DOWNLOADING_FORMS: null,
        APPLICATION_DOWNLOAD_REQUEST: null,
        CLEAR_DOWNLOADED_FORMS: null,
        DOWNLOAD_FORMS_FAILED: null,
        UPDATE_IS_SAVE_DISABLED: null,
        TOGGLE_SHELL_ACCOUNT_NOTIFICATION: null,
        DECLARATION_DISAGREED: null,
        TOGGLE_SAVE_APPLICATION_NOTIFICATION: null,
        DIGITALCONSENT_KILLSWITCH_STARTING: null,
        DIGITALCONSENT_KILLSWITCH_SUCCESS: null,
        DIGITALCONSENT_KILLSWITCH_ERROR: null,
        ASF_CONGRATULATIONS_PAGE_KILLSWITCH_SUCCESS: null,
        ASF_CONGRATULATIONS_PAGE_KILLSWITCH_ERROR: null,
        CONGRATULATIONS_PAGE_DOCUMENT_KILLSWITCH_SUCCESS: null,
        CONGRATULATIONS_PAGE_DOCUMENT_KILLSWITCH_ERROR: null,
        ASF_FEE_KILLSWITCH_SUCCESS: null,
        ASF_FEE_KILLSWITCH_ERROR: null,
        DOWNSIZER_CONTRIBUTION_KILLSWITCH_SUCCESS: null,
        DOWNSIZER_CONTRIBUTION_KILLSWITCH_ERROR: null,
        TRANSITION_COMPLETED: null,
        EXTEND_SESSION: null,
        OFFLINE_APPLICATION_NOTIFICATION: null,
        TOGGLE_OFFLINE_APPLICATION_NOTIFICATION: null,
        CLOSE_INSPECIE_MANUAL_SCENARIO_NOTIFICATION: null,
        SEND_IS_MANAGED_ACCOUNT: null,
        SEND_IS_ADVISER_AUTHORISED: null,
        IS_PENSION_TYPE_SELECTED: null,
        CLIENT_IDENTIFICATION_MODE_START_LOADING_IN_APPLICATION_FORM: null,
        CLIENT_IDENTIFICATION_MODE_LOADED_IN_APPLICATION_FORM: null,
        LOAD_SOURCEOFFUND_LIST: null,
        LOAD_SOURCEOFWEALTH_LIST: null
    }),
    APIUrl: {
        APPLICATION_RETRIEVE_URL: baseUrl + 'applications/',
        BASE_PRODUCTS_URL: baseUrl + 'products/',
        BASE_ADVISERS_URL: baseUrl + 'advisers/',
        ADVISER_FEE_URL: 'fee/functions/',
        MODEL_PORTFOLIO_LIST: '/modelportfolios',
        INVESTMENT_OPTION_LIST: '/funds',
        APPLICATION: '/applications/',
        PRODUCT_LIST: baseUrl + 'products',
        CHECK_FOR_EXCESSIVE_FEE: 'validateexcessivefee',
        GET_ADVISER_SERVICE_FLAGS: 'getadviserservicefeeflags',
        ACCOUNT_TYPE_LIST: '/accounttypes',
        TITLE_LIST: '/titles',
        COUNTRY_LIST: '/countries',
        TFN_EXEMPTIONS_LIST: '/tfnexemptions',
        VALIDATE_PIN: baseUrl + 'application/actions/encryptandvalidatepin',
        GET_BANK_ACCOUNT_DETAILS: '/bankaccounts',
        GET_CLIENT_ACCOUNT_DETAILS: '/accounts?clientoin=',
        GET_SUPER_FUND_LIST: '/superfunds',
        GET_CLIENT_IDENTIFICATION_MODE: '/applications/actions/getidentificationmode',
        GET_ASSET_ALLOCATIONS_LIST: '/assetAllocations',
        ANNUITY_QUOTE_URL: '/applications/annuityQuoteUrl?accountNumber=',
        CLIENTS_SEARCH: 'clients/functions/search',
        CLIENTS_RETRIEVE: 'clients/',
        GET_IS_PRODUCT_REGISTERED: baseUrl + 'advisers/{aid}/products/{pid}/functions/isRegistered',
        NETCODE_BASE: '/functions/',
        GENERATE_SINGLE: 'generatesinglenetcode/?mobilenumber=',
        GENERATE_MULTIPLE: '/generatemultiplenetcode',
        VERIFY_SINGLE_1: 'verifysingle/?mobilenumber=',
        VERIFY_SINGLE_2: '&netcode=',
        VERIFY_MULTIPLE: '/verifymultiple',
        BACKFILE_WORKFILE_URL: baseUrl + 'products/{pid}/workitem/{aid}/generateworkfile/backfile',
        FILENOTE_WORKFILE_URL: baseUrl + 'products/{pid}/workitem/{aid}/generateworkfile/filenote',
        DOWNLOAD_FORMS_URL: baseUrl + 'products/{pid}/applications/functions/{fid}/downloadForms',
        DOWNLOAD_FORM_URL: baseUrl + 'products/{pid}/applications/functions/{fid}/downloadPdfForm/{filter}',
        DOWNLOAD_ALL: baseUrl + 'products/{pid}/applications/{aid}/functions/generateDocuments',
        VERIFY_MOBILE: 'functions/validatemobilenumbers',
        COMMON_KILLSWITCH_URL: baseUrl + 'common/actions/killswitches/',
        COMMON_LOG_ERROR_URL: baseUrl + 'common/actions/logerror',
        COMMON_EXTEND_SESSION_URL: baseUrl + 'common/actions/extend',
        COMMON_GET_CLIENT_IP: baseUrl + 'common/actions/clientip',
        SOURCEOFFUND_LIST: 'sourceOfFund',
        SOURCEOFWEALTH_LIST: 'sourceOfWealth'
    },
    bankAccountDetailsLabel: {
        accountHolderName: 'Name of account holder',
        branchNumber: 'Branch number (BSB)',
        accountNumber: 'Account number'
    },
    SectionNames: {
        INVESTMENT_ALLOCATION: 'investment-allocation-section',
        SUPER_FIRST_TRANSFER: 'super-first-transfer-section',
        ADVICE_FEE: 'advice-fee-section'
    },
    ErrorCodes: {
        TotalIsNot100: '001',
        Diversification: '002',
        WithNonZeroValue: '003',
        AtLeastOne: '004',
        ManagedAccountOrModelPortfolios: '005'
    },
    ValidationTypes: {
        Warning: 'alert-warning',
        Primary: 'alert-primary'
    },
    ProductIds: _productIds,
    AccountTypeCodes: _accountTypeCodes,
    ApplicationProcessModes: KeyMirror({
        ONLINE: null,
        OFFLINE: null
    }),
    ClientIdentificationModes: {
        UNDEFINED: 0,
        NOT_REQUIRED: 1,
        PAPER_FORM: 2,
        E_FORM: 3,
        ANNUITY_WELCOME: 4
    },
    DataToolsConfig: {
        SEARCH_URL_START:
            '/dt_webservice/dt.asmx/DtSearchAddressLinePredictive_jsonp?callback=&ResultLimit=5&AddressLine=',
        SEARCH_URL_END: '&DisplayOnlyCountryCode=AU&'

    },
    Pdfs: {
        INVESTMENT_ALLOCATION: 'http://www.colonialfirststate.com.au/prospects/FS6080.pdf?4'
    },
    StyleSheetValues: {
        PLACEHOLDER_COLOR: '#d0d0d0'
    },
    YesNoValues: _yesNoValues,
    YesNoRadioData: [
        { id: _yesNoValues.YES, name: _yesNoValues.YES_LONG, isHidden: false },
        { id: _yesNoValues.NO, name: _yesNoValues.NO_LONG, isHidden: false }
    ],
    UserTypes: {
        INVESTOR: 'I',
        ADVISER: 'A',
        PUBLIC: 'P'
    },
    ClientTypes: {
        UNKNOWN: 0,
        INDIVIDUAL: 1,
        BUSINESS: 2
    },
    FormKeys: _formKeys,
    InvestorLimits: {
        JOINT_INVESTMENT: 5,
        JOINT_ANNUITIES: 2,
        TRUST_ANNUITIES: 4,
        TRUST_INVESTMENT: 4,
        SMSF_INVESTMENT: 4,
        DEFAULT: 0
    },
    FormModel: formModel,
    messageTypes: KeyMirror({
        info: null,
        warning: null,
        error: null,
        errorNoLine: null,
        infoNoLine: null
    }),
    tfnTypes: KeyMirror({
        individual: null,
        business: null
    }),
    bankAccountConfirmDetailsLabel: {
        nameofAccountHolder: 'Name of account holder',
        branchNumber: 'Branch number (BSB)',
        accountNumber: 'Account number',
        accountInDeffNames: 'Account in different name(s)',
        incomplete: 'INCOMPLETE'
    },
    KeyBoardEvents: {
        space: 32,
        leftArrow: 37,
        rightArrow: 39,
        UpArrow: 38,
        downArrow: 40
    },
    SpinnerSizes: {
        One: 'fa-1x',
        Two: 'fa-2x',
        Three: 'fa-3x'
    },
    DateFormat: 'DD/MM/YYYY',
    DecimalRegex: /[0-9]/,
    SectionId: KeyMirror({
        accountType: null,
        yourDetails: null,
        pensionType: null,
        accountSettings: null,
        fundingYourProduct: null,
        superFirstTransfer: null,
        investmentAllocation: null,
        pensionPayment: null,
        beneficiaryDetails: null,
        regularInvestmentPlan: null,
        autoRebalancing: null,
        incomeDistribution: null,
        portfolioRebate: null,
        adviserFee: null,
        onlineAccess: null,
        specialRequests: null,
        adviserAuthority : null,
        adviserAttestation: null,
        inSpecieTransfer: null
    }),
    TrusteeLabels: _trusteeTypeLabels,
    isTrue: 'True',
    MaxNumberOfInvestor: 5,
    OriginationSources: _originationSources,
    OriginationTypes: _originationTypes,
    CfpAdviserDealerCode: '0851',
    DaysOfTheWeek: _daysOfTheWeek,
    MonthNames: _monthNames,
    KillSwitches: {
        DIGITAL_CONSENT: 'digitalconsent',
        ASF_FORM: 'asfForm',
        ASF_CONGRATULATIONS_PAGE: 'asfCongratulationsPage',
        DOWNSIZER_CONTRIBUTION: 'downsizerContribution',
        CONGRATULATIONS_PAGE_DOCUMENT: 'congratulationsPageDocument',
        INCOME_DISTRIBUTION: 'incomeDistribution'
    },
    KycSources:
    {
        FMS: 'FMS',
        COMMSEE: 'COMMSEE'
    },
    CustomTitle: 'CUSTOM_TITLE',
    ClientSources: {
        FMS: 'FMS',
        XPLAN:'XPLAN'
    },
    Clear: 'clear',
    SofSowOther:
    {
        SOFOT: 'SFOT',
        SOWOT: 'SWOT'
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/ApplicationConstants.js